import { defineComponent as _defineComponent } from 'vue'
import { useSlots } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectTable',
  props: {
    items: null,
    fields: { default: () => [] }
  },
  emits: ["item-selected"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'item-selected', value: unknown): void;
}), expose: any, slots: any, attrs: any }) {





const slots = useSlots();

const itemSelected = (item: unknown) => {
    emit('item-selected', item);
};

return { __sfc: true,emit, slots, itemSelected }
}

})